(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[148],{

/***/ 13166:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/api-keys",
      function () {
        return __webpack_require__(45689);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ withAuthWall; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_user_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56621);



const AuthWallWrapper = (param)=>{
    let { Content  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { user  } = (0,_context_user_context__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .a)();
    if (user === "loading" || !true) {
        return null;
    }
    if (!(user === null || user === void 0 ? void 0 : user.isSignedUp)) {
        void router.push("/login?redirectPath=".concat(router.asPath));
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {
        user: user
    });
};
/**
 * We don’t know if a user is logged in during server-side-rendering, but we want
 * some pages to be available behind the auth wall. Once UserContext is populated
 * with the result of /api/me, we want to redirect guest users from to /.
 * use `withAuthWall` to enable this behavior.
 *
 * You can also get user object from Content props and thus avoid extra checks.
 */ const withAuthWall = (Content)=>{
    return ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthWallWrapper, {
            Content: Content
        });
};


/***/ }),

/***/ 13475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ PageContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59452);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56042);


const PageContainer = (param)=>{
    let { children , sx =[]  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        sx: {
            background: "linear-gradient(180deg, #FAFBFC 0%, rgba(250, 251, 252, 0) 100%)"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            sx: [
                {
                    paddingTop: {
                        xs: 5,
                        md: 9
                    },
                    paddingBottom: {
                        xs: 5,
                        md: 9
                    }
                },
                ...Array.isArray(sx) ? sx : [
                    sx
                ]
            ],
            children: children
        })
    });
};


/***/ }),

/***/ 17524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ TopNavigationTabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59452);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56042);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80613);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18258);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82577);




const a11yProps = (index)=>({
        id: "simple-tab-".concat(index),
        "aria-controls": "simple-tabpanel-".concat(index)
    });
const TopNavigationTabs = ()=>{
    var ref;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            borderBottom: 1,
            borderColor: (param)=>{
                let { palette  } = param;
                return palette.gray[20];
            },
            borderBottomStyle: "solid",
            marginTop: {
                xs: 2,
                md: 0
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                value: (ref = _utils__WEBPACK_IMPORTED_MODULE_2__/* .dashboardPages.find */ .p.find((dashboardPage)=>router.asPath.includes(dashboardPage.tabHref))) === null || ref === void 0 ? void 0 : ref.tabHref,
                "aria-label": "settings-tabs",
                children: _utils__WEBPACK_IMPORTED_MODULE_2__/* .dashboardPages.map */ .p.map((param, i)=>/*#__PURE__*/ {
                    let { tabTitle , tabHref  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        label: tabTitle,
                        value: tabHref,
                        href: tabHref,
                        component: "a",
                        onClick: (event)=>{
                            event.preventDefault();
                            void router.push(tabHref);
                        },
                        ...a11yProps(i)
                    }, tabHref);
                })
            })
        })
    });
};


/***/ }),

/***/ 82577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ dashboardPages; },
  "i": function() { return /* binding */ getDashboardSectionCards; }
});

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var index_es = __webpack_require__(95096);
// EXTERNAL MODULE: ./src/lib/config.ts
var config = __webpack_require__(1175);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(59627);
;// CONCATENATED MODULE: ./src/components/icons/block-icon.tsx


const BlockIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
        ...props,
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0 4C0 1.8125 1.75 0 4 0H24C26.1875 0 28 1.8125 28 4V24C28 26.25 26.1875 28 24 28H4C1.75 28 0 26.25 0 24V4ZM4.5 3C3.625 3 3 3.6875 3 4.5C3 5.375 3.625 6 4.5 6C5.3125 6 6 5.375 6 4.5C6 3.6875 5.3125 3 4.5 3ZM23.5 6C24.3125 6 25 5.375 25 4.5C25 3.6875 24.3125 3 23.5 3C22.625 3 22 3.6875 22 4.5C22 5.375 22.625 6 23.5 6ZM4.5 22C3.625 22 3 22.6875 3 23.5C3 24.375 3.625 25 4.5 25C5.3125 25 6 24.375 6 23.5C6 22.6875 5.3125 22 4.5 22ZM23.5 25C24.3125 25 25 24.375 25 23.5C25 22.6875 24.3125 22 23.5 22C22.625 22 22 22.6875 22 23.5C22 24.375 22.625 25 23.5 25Z",
            fill: "#C1CFDE"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/sparkles-icon.tsx


const SparklesIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
        ...props,
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M20.4375 5.375L24 4L25.3125 0.5C25.375 0.1875 25.6875 0 26 0C26.25 0 26.5625 0.1875 26.625 0.5L28 4L31.5 5.375C31.8125 5.4375 32 5.75 32 6C32 6.3125 31.8125 6.625 31.5 6.6875L28 8L26.625 11.5625C26.5625 11.8125 26.25 12 26 12C25.6875 12 25.375 11.8125 25.3125 11.5625L24 8L20.4375 6.6875C20.125 6.625 20 6.3125 20 6C20 5.75 20.125 5.4375 20.4375 5.375ZM16.0625 11.75L23.1875 15C23.5625 15.1875 23.8125 15.5625 23.8125 15.9375C23.8125 16.3125 23.5625 16.6875 23.1875 16.875L16.0625 20.125L12.8125 27.25C12.625 27.625 12.25 27.875 11.875 27.875C11.5 27.875 11.125 27.625 11 27.25L7.6875 20.125L0.5625 16.875C0.1875 16.6875 0 16.3125 0 15.9375C0 15.5625 0.1875 15.1875 0.5625 15L7.6875 11.75L11 4.625C11.125 4.25 11.5 4 11.875 4C12.25 4 12.625 4.25 12.8125 4.625L16.0625 11.75ZM25.3125 20.5C25.375 20.1875 25.6875 20 26 20C26.25 20 26.5625 20.1875 26.625 20.5L28 24L31.5 25.375C31.8125 25.4375 32 25.75 32 26C32 26.3125 31.8125 26.625 31.5 26.6875L28 28L26.625 31.5625C26.5625 31.8125 26.25 32 26 32C25.6875 32 25.375 31.8125 25.3125 31.5625L24 28L20.4375 26.6875C20.125 26.625 20 26.3125 20 26C20 25.75 20.125 25.4375 20.4375 25.375L24 24L25.3125 20.5Z",
            fill: "#C1CFDE"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/dashboard/utils.ts




const dashboardPages = [
    {
        tabTitle: "Dashboard",
        tabHref: "/dashboard"
    },
    {
        tabTitle: "Blocks",
        tabHref: "/blocks"
    },
    {
        tabTitle: "API Keys",
        tabHref: "/settings/api-keys"
    }
];
const getDashboardSectionCards = (props)=>{
    return {
        create: [
            {
                title: "Build a block",
                colorGradient: "linear-gradient(291.34deg, #FFB172 -4.12%, #D082DE 53.49%, #9482FF 91.74%, #84E6FF 151.68%)",
                colorGradientOnHover: "linear-gradient(292.67deg, #FFB172 44.38%, #D082DE 83.44%, #9482FF 109.38%, #84E6FF 150.02%)",
                description: "Read the quickstart guide and learn how to create and use blocks",
                link: {
                    title: "Read the guide",
                    href: "/docs/developing-blocks"
                }
            },
            {
                title: "Publish a block",
                colorGradient: "linear-gradient(310.17deg, #FFB172 -167.67%, #9482FF 13.54%, #84E6FF 126.83%)",
                colorGradientOnHover: "linear-gradient(304.41deg, #FFB172 -167.57%, #9482FF -22.66%, #84E6FF 53.07%)",
                description: "Build a block you’re ready to release on the Hub?",
                link: {
                    title: "Publish a block",
                    href: config/* shouldAllowNpmBlockPublishing */.yI ? "/blocks/publish" : "".concat(props.profileLink, "/blocks")
                }
            },
            {
                title: "Create a Type",
                colorGradient: "linear-gradient(91.21deg, #FFB172 -84.62%, #9482FF 62.56%, #84E6FF 154.58%)",
                colorGradientOnHover: "linear-gradient(91.21deg, #FFB172 -84.54%, #9482FF 27.8%, #84E6FF 98.03%)",
                description: "Types are a formal way to describe data, links, properties and entities",
                link: {
                    title: "Create a type",
                    onClick: props.openCreateSchemaModal
                }
            }
        ],
        manage: [
            {
                title: "Create and manage API keys",
                description: "Your API key will allow you to search for and blocks by name, author, or compatible data structure",
                link: {
                    title: "Manage keys",
                    href: "/settings/api-keys"
                },
                icon: index_es/* faKey */.DD4,
                variant: "secondary"
            },
            {
                /** @todo show "Complete your public profile" when profile details are editable */ title: "View your public profile",
                description: "Your bio and links help others discover your work, and appear alongside your public types and blocks",
                link: {
                    title: "View Profile",
                    href: props.profileLink
                },
                icon: index_es/* faUserPen */.iDc,
                variant: "secondary"
            },
            {
                title: "Manage blocks",
                description: "View and modify the listings for blocks you’ve published on the Hub",
                link: {
                    title: "Manage blocks",
                    href: "".concat(props.profileLink, "/blocks")
                },
                CustomIcon: BlockIcon,
                variant: "secondary"
            },
            {
                title: "Manage types",
                description: "View and update the types you’ve created and made public on the Hub",
                link: {
                    title: "Manage types",
                    href: "".concat(props.profileLink, "/schemas")
                },
                icon: index_es/* faAsterisk */.$X1,
                variant: "secondary"
            }
        ],
        explore: [
            {
                title: "Browse blocks for inspiration",
                description: "View and test our the most popular blocks on the Hub to see how they work",
                link: {
                    title: "Browse blocks",
                    href: "/hub"
                },
                CustomIcon: SparklesIcon,
                variant: "secondary"
            }
        ]
    };
};


/***/ }),

/***/ 45689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ api_keys_page; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Typography/Typography.js
var Typography = __webpack_require__(38079);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(59452);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/button.tsx + 2 modules
var components_button = __webpack_require__(36941);
// EXTERNAL MODULE: ./src/components/icons/index.ts + 19 modules
var icons = __webpack_require__(10231);
// EXTERNAL MODULE: ./src/components/link.tsx
var components_link = __webpack_require__(70338);
// EXTERNAL MODULE: ./src/components/pages/auth-wall.tsx
var auth_wall = __webpack_require__(69123);
// EXTERNAL MODULE: ./src/lib/api-client.ts + 40 modules
var api_client = __webpack_require__(83585);
// EXTERNAL MODULE: ./src/components/modal/modal.tsx
var modal = __webpack_require__(58349);
;// CONCATENATED MODULE: ./src/components/pages/dashboard/api-key-renderer.tsx





const ApiKeyRenderer = (param)=>{
    let { apiKey , closeModal , regenerate , keyName  } = param;
    const [copied, setCopied] = (0,react.useState)(false);
    const copyApiKey = ()=>{
        if (navigator.clipboard !== undefined) {
            // Chrome
            setCopied(true);
            return navigator.clipboard.writeText(apiKey);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto",
                    marginBottom: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ApiKeyGeneratedIcon */.KX, {
                    sx: {
                        fontSize: "52px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                sx: {
                    fontFamily: "Apercu Pro",
                    fontSize: "35.1625px",
                    lineHeight: "120%",
                    color: "#37434F",
                    marginBottom: 2
                },
                children: [
                    keyName,
                    " ",
                    regenerate ? "regenerated" : "generated"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                sx: {
                    marginBottom: 2
                },
                children: [
                    "Your key ",
                    keyName,
                    " has been ",
                    regenerate ? "regenerated" : "generated",
                    ".",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    regenerate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            "The previous key will no longer work.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    }) : null,
                    "Here is your new key - make a note of it, ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "we can't show it to you again!"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                onMouseLeave: ()=>setCopied(false),
                sx: {
                    marginBottom: 2,
                    border: "1px solid #F2F5FA",
                    borderRadius: 2,
                    p: 2,
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        "data-testid": "api-key-value",
                        sx: {
                            overflowWrap: "anywhere",
                            textAlign: "left",
                            color: "#91A5BA"
                        },
                        children: apiKey
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                            sx: {
                                transition: "all 0.2s ease-in-out",
                                display: "flex",
                                alignItems: "center"
                            },
                            onClick: copyApiKey,
                            children: copied ? "✓ Copied" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CopyIcon */.TI, {
                                        width: "auto",
                                        height: "1em",
                                        sx: {
                                            fontSize: "1em",
                                            marginRight: 1
                                        }
                                    }),
                                    "Copy to Clipboard"
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "1fr"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                    onClick: closeModal,
                    sx: {
                        borderRadius: 2
                    },
                    children: "Go back"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/dashboard/generate-api-modal.tsx








const GenerateApiModal = (param)=>{
    let { close , keyNameToRegenerate , refetchKeyList  } = param;
    const [apiKey, setApiKey] = (0,react.useState)("");
    const [keyName, setKeyName] = (0,react.useState)(keyNameToRegenerate || "");
    const regenerate = !!keyNameToRegenerate;
    const createKey = (event)=>{
        event.preventDefault();
        /** @todo handle errors and show the user a msg */ void api_client/* apiClient.generateApiKey */.x.generateApiKey({
            displayName: keyName
        }).then((param)=>{
            let { data  } = param;
            if (data) {
                setApiKey(data.apiKey);
            }
            refetchKeyList();
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        open: true,
        onClose: close,
        children: apiKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ApiKeyRenderer, {
            keyName: keyName,
            apiKey: apiKey,
            closeModal: close,
            regenerate: regenerate
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        background: "#FFF6ED",
                        borderRadius: "100%",
                        width: "52px",
                        height: "52px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        marginBottom: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WarningIcon */.aN, {
                        width: "auto",
                        height: "1em"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        fontFamily: "Apercu Pro",
                        fontSize: "35.1625px",
                        lineHeight: "120%",
                        color: "#37434F",
                        marginBottom: 2
                    },
                    children: regenerate ? "Regenerate ".concat(keyName) : "Generate API Key"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        marginBottom: 1.5
                    },
                    children: regenerate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "Regenerating the ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: keyName
                            }),
                            " key will invalidate it. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "This could break any application that relies on it. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "Are you sure you want to regenerate it?"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Name your key."
                            }),
                            "Key names usually describe where they’re used, ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "such as “Production”."
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: createKey,
                    children: [
                        regenerate ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            value: keyName,
                            onChange: (event)=>{
                                setKeyName(event.target.value);
                            },
                            component: "input",
                            sx: (theme)=>({
                                    background: "#FFFFFF",
                                    border: "1px solid ".concat(theme.palette.gray[30]),
                                    width: "100%",
                                    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                                    borderRadius: "6px",
                                    marginBottom: 2
                                }),
                            py: 1,
                            px: 2,
                            placeholder: "Key Name",
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "1fr",
                                    sm: "1fr 1fr"
                                },
                                columnGap: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                    color: regenerate ? "warning" : "purple",
                                    type: "submit",
                                    variant: "tertiary",
                                    sx: {
                                        marginBottom: 1
                                    },
                                    squared: true,
                                    children: regenerate ? "Regenerate Key" : "Create Key"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                    onClick: close,
                                    color: "gray",
                                    variant: "tertiary",
                                    sx: {
                                        marginBottom: 1
                                    },
                                    squared: true,
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/pages/dashboard/page-container.tsx
var page_container = __webpack_require__(13475);
// EXTERNAL MODULE: ./src/components/pages/dashboard/top-navigation-tabs.tsx
var top_navigation_tabs = __webpack_require__(17524);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Table/Table.js + 1 modules
var Table = __webpack_require__(54036);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(72924);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(17666);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/TableContainer/TableContainer.js + 1 modules
var TableContainer = __webpack_require__(13701);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(66898);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(99615);
;// CONCATENATED MODULE: ./src/components/table.tsx







const table_Table = (param)=>{
    let { header , rows  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
            sx: {
                minWidth: 650
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                        children: header.map((title)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    color: "#4D5C6C",
                                    fontWeight: 500,
                                    whiteSpace: "nowrap"
                                },
                                children: title
                            }, title))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                    children: rows.map((row, rowIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                            sx: {
                                "&:last-child td, &:last-child th": {
                                    border: 0
                                }
                            },
                            children: row.map((cell, colIndex)=>typeof cell === "string" ? // eslint-disable-next-line react/no-array-index-key
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    children: cell
                                }, "col-".concat(colIndex)) : cell)
                        }, "row-".concat(rowIndex)))
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/formatDistance/index.js + 11 modules
var formatDistance = __webpack_require__(29193);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/formatRelative/index.js + 22 modules
var formatRelative = __webpack_require__(52959);
;// CONCATENATED MODULE: ./src/components/table-cells.tsx



const DateTimeCell = (param)=>{
    let { timestamp  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    marginBottom: 1
                },
                children: (0,formatDistance/* default */.Z)(typeof timestamp === "string" ? new Date(timestamp) : timestamp, new Date(), {
                    addSuffix: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    fontSize: "0.9rem",
                    color: "#64778C"
                },
                children: (0,formatRelative/* default */.Z)(typeof timestamp === "string" ? new Date(timestamp) : timestamp, new Date())
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/settings/api-keys.page.tsx














const ApiKeys = ()=>{
    var ref;
    const [activeApiKeys, setActiveApiKeys] = (0,react.useState)([]);
    const [generateKeyStatus, setGenerateStatus] = (0,react.useState)({
        showModal: false
    });
    const fetchAndSetApiKeys = ()=>api_client/* apiClient.getUserApiKeys */.x.getUserApiKeys().then((param)=>{
            let { data  } = param;
            return data ? setActiveApiKeys(data.apiKeysMetadata.filter((key)=>!key.revokedAt)) : null;
        });
    (0,react.useEffect)(()=>{
        /** @todo handle errors and show the user a msg */ void fetchAndSetApiKeys();
    }, []);
    const tableRows = (0,react.useMemo)(()=>activeApiKeys.map((key)=>[
                key.displayName,
                key.publicId,
                key.lastUsedAt ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeCell, {
                    timestamp: key.lastUsedAt
                }, "lastUsed") : "Never",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeCell, {
                    timestamp: key.createdAt
                }, "createdAt")
            ]), [
        activeApiKeys
    ]);
    const activeKey = activeApiKeys[0];
    const closeGenerateModal = ()=>{
        setGenerateStatus({
            showModal: false,
            keyToRegenerate: undefined
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Block Protocol – Dashboard"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_navigation_tabs/* TopNavigationTabs */.g, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_container/* PageContainer */._, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "bpTitle",
                        mb: 2,
                        children: "Access the API"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        py: 4,
                        display: {
                            xs: "block",
                            md: "flex"
                        },
                        alignItems: "flex-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                boxShadow: "0px 4px 11px rgba(39, 50, 86, 0.04), 0px 2.59259px 6.44213px rgba(39, 50, 86, 0.08), 0px 0.5px 1px rgba(39, 50, 86, 0.15)",
                                background: "white",
                                width: "100%",
                                borderRadius: 2
                            },
                            p: {
                                xs: 3,
                                md: 6
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        typography: "bpLargeText",
                                        fontWeight: "500"
                                    },
                                    children: "API Keys"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        my: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                typography: "bpBodyCopy"
                                            },
                                            children: "These keys allow you to access the block protocol from within your application."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            sx: {
                                                typography: "bpBodyCopy"
                                            },
                                            children: [
                                                "Keep them private to prevent other people from accessing your account. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                                    href: "/docs/embedding-blocks#discovering-blocks",
                                                    children: "Learn More"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !!tableRows.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(table_Table, {
                                    header: [
                                        "Name",
                                        "Public ID",
                                        "Last Used",
                                        "Created"
                                    ],
                                    rows: tableRows
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        paddingTop: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                            color: activeKey ? "warning" : "gray",
                                            onClick: ()=>setGenerateStatus({
                                                    showModal: true,
                                                    keyToRegenerate: activeKey
                                                }),
                                            sx: {
                                                width: {
                                                    xs: "100%",
                                                    md: "auto"
                                                }
                                            },
                                            variant: "tertiary",
                                            children: activeKey ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WarningIcon */.aN, {
                                                        width: "auto",
                                                        height: "1em",
                                                        sx: {
                                                            fontSize: "1em",
                                                            marginRight: 1
                                                        }
                                                    }),
                                                    " ",
                                                    "Regenerate API Key"
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "Create new key"
                                            })
                                        }),
                                        generateKeyStatus.showModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GenerateApiModal, {
                                            close: closeGenerateModal,
                                            keyNameToRegenerate: (ref = generateKeyStatus.keyToRegenerate) === null || ref === void 0 ? void 0 : ref.displayName,
                                            refetchKeyList: fetchAndSetApiKeys
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var api_keys_page = ((0,auth_wall/* withAuthWall */.p)(ApiKeys));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [784,417,774,888,179], function() { return __webpack_exec__(13166); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);